export default __webpack_public_path__ + "static/media/AmbiguitÖ lunare.d966939d.jpg";